import { store } from '@pomofocus/shared-client';
export default function configureStore() {
    return store;
}
